<template>
    <div class="ItemModalContainer" >
        <div class="modal" @click.self="closeModal">
            <div class="modalForm" >
                <div class="modalHeader">
                    <div class="modalHeaderText">Edit Conditional Logic</div>
                    <button @click="closeModal" class="closeButton"><i class="fa-solid fa-square-xmark"></i></button>
                </div>
                <div class="modalBody">
                    NOTE: Use CURRENT_DATE or CURRENT_DATE_TIME for the current date only or current date and time, respectively.   Date and time should be ISO formatted be formatted: YYYY-MM-DD OR YYYY-MM-DDTHH:mm:ss.sssZ.
                    <ConditionGroup v-if="conditions"  :conditions="conditions" :onChanged="updateConditions" :key="counter" ></ConditionGroup>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ConditionGroup from './ConditionGroup.vue';

export default {
    name: 'ConditionalExpressionModal',
    components: { ConditionGroup},
    props: {
        conditions: {
            default: null
        },
        onConditionsChanged: {
            type: Function
        }
    },
    data: function() {
        return {  
            counter: 0
        }
    },
    mounted() {
        document.addEventListener("keydown", (e) => {
            if (e.key == 'Escape')
                this.closeModal();
        });
    },
    methods: {
        closeModal: function() {
            this.$emit('close');
        },
        updateConditions: async  function(conditionGroup) {
            if(this.onConditionsChanged)
                this.onConditionsChanged(conditionGroup);
        },
    }
  
}
</script>

<style scoped src="@/assets/css/shared/itemModal.css"></style>
<style scoped>
    .modalForm { 
        width: unset;
        height: 50%;
        position: relative;
        border: solid 2px black;
        padding: 0px;
    }

    .modalHeader {
        display: flex;
        width: 100%;
        background-color: darkgray;
        height: 25px;
        flex-direction: row;
        justify-content: space-between;
        border-bottom: solid 2px black;
        align-items:center;
    }

    .modalBody { 
        overflow: auto;    
        padding: 0px 20px 20px;  
        height: 80%;
        position: relative;
    }

    .modalHeaderText {
        font-weight: bold;
        margin-left: 25px;
    }
    .closeButton {
        cursor: pointer;
        color: darkred;
        border: none;
        font-size: 25px;
        padding: 0px;
        background: transparent;
        margin-right: 10px;
        margin-top: 2px;
    }
</style>